import React from "react";

import classNames from "classnames";

import { SWReactIcons } from "@similarweb/icons";

import { swSettings } from "app/common/services/swSettings";
import { allTrackers } from "app/services/track/track";
import I18n from "pro-features/components/WithTranslation/src/I18n";

export interface GAPromoTooltipContentFooterProps {
    closePopup?: () => void;
    isAccountGAConnected: boolean;
    isActive?: boolean;
    isPrivate?: boolean;
    linkText?: string;
    metric?: string;
    onGAWizardModalOpen: () => void;
    openTooltip?: boolean;
}

export class GAPromoTooltipContentFooter extends React.Component<GAPromoTooltipContentFooterProps> {
    private isAccountGAConnected: boolean;
    private verificationType: string;

    constructor(props: GAPromoTooltipContentFooterProps) {
        super(props);

        const metric = props.metric ? `${props.metric}/` : "";

        this.isAccountGAConnected = props.isAccountGAConnected;
        if (this.props.isPrivate) {
            this.verificationType = `${metric}Private`;
        } else {
            if (this.props.isActive) {
                this.verificationType = `${metric}Public`;
            } else {
                this.verificationType = `${metric}Non-Verified`;
            }
        }
    }

    track(suggestConect: boolean, force?: boolean) {
        if (force) {
            allTrackers.trackEvent(
                "Popup",
                "click",
                suggestConect
                    ? "Introduction popup Connect GA/Get your website verified"
                    : "Introduction popup Connect GA/Learn more",
            );
        } else {
            allTrackers.trackEvent(
                "Popup",
                "click",
                suggestConect
                    ? `${this.verificationType}/Get your website verified`
                    : `${this.verificationType}/Learn more`,
            );
        }
    }

    onClick() {
        if (!this.isAccountGAConnected) {
            this.props.onGAWizardModalOpen();
        } else {
            window.open("https://support.similarweb.com/hc/en-us/articles/208420125");
        }
        this.track(!this.isAccountGAConnected, this.props.openTooltip);
        if (this.props.closePopup) {
            this.props.closePopup();
        }
    }

    render() {
        if (swSettings.components.Home.resources.GaMode !== "Skip" && !swSettings.user.disableGA) {
            if (!this.isAccountGAConnected) {
                return (
                    <div
                        className="ga-promo-tooltip-content-footer"
                        onClick={this.onClick.bind(this)}
                    >
                        <span className="ga-verified-icon" />
                        <span className="verified-data-promotion-text">
                            <I18n>common.estimation.vs.verified.footer.text</I18n>
                        </span>
                        <SWReactIcons iconName="chev-right" />
                    </div>
                );
            } else {
                return (
                    <div className={classNames("GAVerified-tooltip-link")}>
                        <a onClick={this.onClick.bind(this)}>
                            <I18n>{this.props.linkText}</I18n>
                        </a>
                    </div>
                );
            }
        } else {
            return <div className={classNames("GAVerified-tooltip-link")} />;
        }
    }
}
